import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/error-reporter.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/sw-register.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/ui/ConfirmHost.tsx");
